// extracted by mini-css-extract-plugin
export var body = "_i4-0";
export var sectionHeader = "_i4-4";
export var shortcutColumns = "_i4-2";
export var shortcutList = "_i4-1";
export var shortcutSection = "_i4-3";